import React, { Component } from "react";
import { withMapControl } from "../../shared/containers/containerMapControl";
import LayersIcon from "@mui/icons-material/Layers";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import styles from "./layerMapControl.module.scss";
import TooltipWrapper from "../../shared/items/contols/tooltipWrapper";
import { withAuth } from "../../shared/containers/containerAuth";
import { withChoosedCar } from "../../shared/containers/containerChoosedCar";
import { Radio } from "@mui/material";
import { withCars } from "../../shared/containers/containerCars";

const ANIMATION_ROUTE = "ANIMATION_ROUTE";

class LayerMapControl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      mapOverlayers: {},
    };
  }

  componentDidMount() {
    const { mapOverlayers, data } = this.props;

    mapOverlayers.viewAnimation = true;
    const animationRoutes = !!localStorage.getItem(ANIMATION_ROUTE) ? JSON.parse(localStorage.getItem(ANIMATION_ROUTE)) : [];
    animationRoutes.forEach((item) => {
      if (data.email === item.email) {
        mapOverlayers.viewAnimation = item.value;
      }
    });

    this.setState({ mapOverlayers });
  }

  handleLayer(name) {
    const { mapOverlayers, onSetOverlayers } = this.props;
    mapOverlayers[name] = !mapOverlayers[name];

    onSetOverlayers(mapOverlayers);
    this.setState({ mapOverlayers });
  }

  onChangeAnimation(value) {
    const { data } = this.props;

    const animationRoutes = !!localStorage.getItem(ANIMATION_ROUTE) ? JSON.parse(localStorage.getItem(ANIMATION_ROUTE)) : [];

    if (animationRoutes.length === 0) {
      animationRoutes.push({ email: data.email, value: value });
    }

    animationRoutes.forEach((item) => {
      if (data.email === item.email) {
        item.value = value;
      }
    });

    localStorage.setItem(ANIMATION_ROUTE, JSON.stringify(animationRoutes));

    const { mapOverlayers, onSetOverlayers } = this.props;
    mapOverlayers.viewAnimation = value;

    onSetOverlayers(mapOverlayers);
    this.setState({ mapOverlayers });
  }

  render() {
    const {
      viewAnimation,
      viewRoute,
      viewOrigenalPositions,
      viewStopMarker,
      viewStartFinishMarker,
      viewPosition,
      viewFuelingMarker,
      viewDrainMarker,
      viewGpsJammingMarker,
      viewSpeedingPointsMarker,
      viewGeozones,
      viewDump,
      viewDump2,
      viewSand,
    } = this.state.mapOverlayers;

    const { isOpen } = this.state;
    const { routeBlock = true, data, listUnits, choosedCarId } = this.props;

    let isDumpUnit = false;
    let isDump2Unit = false;
    let isSandUnit = false;

    if (choosedCarId !== null) {
      const unit = listUnits.filter((x) => {
        return x.id === choosedCarId;
      })[0];

      if (unit !== undefined) {
        isDump2Unit = unit.sensors.DU2 !== undefined;
        isDumpUnit = unit.sensors.DU1 !== undefined;
        isSandUnit = unit.sensors.SAND !== undefined;
      }
    }

    return (
      <div className={styles.overlayer_control_container}>
        {isOpen ? (
          <div className={styles.overlayerOpenContainer}>
            <TooltipWrapper title={"Закрыть панель объектов"} position="left">
              <div className={styles.layersIconControlClose} onClick={() => this.setState({ isOpen: false })}>
                <HighlightOffIcon fontSize="small" />
              </div>
            </TooltipWrapper>

            {routeBlock ? (
              <div>
                <div className={styles.radioContainer}>
                  <div
                    className={styles.itemRadio}
                    onClick={() => {
                      this.onChangeAnimation(true);
                    }}
                  >
                    <Radio checked={viewAnimation === true} size="small" /> C анимацией
                  </div>
                  <div
                    className={styles.itemRadio}
                    onClick={() => {
                      this.onChangeAnimation(false);
                    }}
                  >
                    <Radio checked={viewAnimation === false} size="small" /> Без анимации
                  </div>
                </div>

                <TooltipWrapper title={`${viewRoute ? "Скрыть" : "Показать"} маршрут`} position="left">
                  <div
                    className={viewRoute ? styles.checkbox_layer : styles.checkbox_layer_disable}
                    onClick={this.handleLayer.bind(this, "viewRoute")}
                  >
                    <span className={styles.statuses_container}>Маршрут</span>
                  </div>
                </TooltipWrapper>

                {data.permissions.includes(11015) ? (
                  <TooltipWrapper title={`${viewOrigenalPositions ? "Скрыть" : "Показать"} оригинальный маршрут`} position="left">
                    <div
                      className={viewOrigenalPositions ? styles.checkbox_layer : styles.checkbox_layer_disable}
                      onClick={this.handleLayer.bind(this, "viewOrigenalPositions")}
                    >
                      <span className={styles.statuses_container}>Оригинальный маршрут</span>
                    </div>
                  </TooltipWrapper>
                ) : null}

                {isDumpUnit ? (
                  <TooltipWrapper title={`${viewDump ? "Скрыть" : "Показать"} маршрут работы отвала`} position="left">
                    <div
                      className={viewDump ? styles.checkbox_layer : styles.checkbox_layer_disable}
                      onClick={this.handleLayer.bind(this, "viewDump")}
                    >
                      <span className={styles.statuses_container}>Маршрут работы отвала</span>
                    </div>
                  </TooltipWrapper>
                ) : null}

                {isDump2Unit ? (
                  <TooltipWrapper title={`${viewDump2 ? "Скрыть" : "Показать"} маршрут работы отвала`} position="left">
                    <div
                      className={viewDump2 ? styles.checkbox_layer : styles.checkbox_layer_disable}
                      onClick={this.handleLayer.bind(this, "viewDump2")}
                    >
                      <span className={styles.statuses_container}>Маршрут работы второго отвала</span>
                    </div>
                  </TooltipWrapper>
                ) : null}

                {isSandUnit ? (
                  <TooltipWrapper title={`${viewSand ? "Скрыть" : "Показать"} маршрут работы пескосолераспределителя`} position="left">
                    <div
                      className={viewSand ? styles.checkbox_layer : styles.checkbox_layer_disable}
                      onClick={this.handleLayer.bind(this, "viewSand")}
                    >
                      <span className={styles.statuses_container}>Маршрут работы пескосолераспределителя</span>
                    </div>
                  </TooltipWrapper>
                ) : null}

                <TooltipWrapper title={`${viewStopMarker ? "Скрыть" : "Показать"} стоянки`} position="left">
                  <div
                    className={viewStopMarker ? styles.checkbox_layer : styles.checkbox_layer_disable}
                    onClick={this.handleLayer.bind(this, "viewStopMarker")}
                  >
                    <span className={styles.statuses_container}>Стоянки</span>
                  </div>
                </TooltipWrapper>

                <TooltipWrapper title={`${viewFuelingMarker ? "Скрыть" : "Показать"} заправки`} position="left">
                  <div
                    className={viewFuelingMarker ? styles.checkbox_layer : styles.checkbox_layer_disable}
                    onClick={this.handleLayer.bind(this, "viewFuelingMarker")}
                  >
                    <span className={styles.statuses_container}>Заправки</span>
                  </div>
                </TooltipWrapper>

                <TooltipWrapper title={`${viewDrainMarker ? "Скрыть" : "Показать"} сливы топлива`} position="left">
                  <div
                    className={viewDrainMarker ? styles.checkbox_layer : styles.checkbox_layer_disable}
                    onClick={this.handleLayer.bind(this, "viewDrainMarker")}
                  >
                    <span className={styles.statuses_container}>Сливы топлива</span>
                  </div>
                </TooltipWrapper>

                <TooltipWrapper title={`${viewGpsJammingMarker ? "Скрыть" : "Показать"} глушение GPS`} position="left">
                  <div
                    className={viewGpsJammingMarker ? styles.checkbox_layer : styles.checkbox_layer_disable}
                    onClick={this.handleLayer.bind(this, "viewGpsJammingMarker")}
                  >
                    <span className={styles.statuses_container}>Глушение GPS</span>
                  </div>
                </TooltipWrapper>

                <TooltipWrapper title={`${viewSpeedingPointsMarker ? "Скрыть" : "Показать"} привышение скорости`} position="left">
                  <div
                    className={viewSpeedingPointsMarker ? styles.checkbox_layer : styles.checkbox_layer_disable}
                    onClick={this.handleLayer.bind(this, "viewSpeedingPointsMarker")}
                  >
                    <span className={styles.statuses_container}>Привышение скорости</span>
                  </div>
                </TooltipWrapper>

                <TooltipWrapper title={`${viewPosition ? "Скрыть" : "Показать"} маркер позиции`} position="left">
                  <div
                    className={viewPosition ? styles.checkbox_layer : styles.checkbox_layer_disable}
                    onClick={this.handleLayer.bind(this, "viewPosition")}
                  >
                    <span className={styles.statuses_container}>Маркер позиции</span>
                  </div>
                </TooltipWrapper>

                <TooltipWrapper title={`${viewStartFinishMarker ? "Скрыть" : "Показать"} маркеры начала и конца`} position="left">
                  <div
                    className={viewStartFinishMarker ? styles.checkbox_layer : styles.checkbox_layer_disable}
                    onClick={this.handleLayer.bind(this, "viewStartFinishMarker")}
                  >
                    <span className={styles.statuses_container}>Маркеры начала и конца</span>
                  </div>
                </TooltipWrapper>
              </div>
            ) : null}

            <TooltipWrapper title={`${viewGeozones ? "Скрыть" : "Показать"} геозоны`} position="left">
              <div
                className={viewGeozones ? styles.checkbox_layer : styles.checkbox_layer_disable}
                onClick={this.handleLayer.bind(this, "viewGeozones")}
              >
                <span className={styles.statuses_container}>Геозоны</span>
              </div>
            </TooltipWrapper>
          </div>
        ) : (
          <TooltipWrapper title={"Открыть панель объектов"} position="left">
            <div className={styles.layersIconControl} onClick={() => this.setState({ isOpen: true })}>
              <LayersIcon />
            </div>
          </TooltipWrapper>
        )}
      </div>
    );
  }
}

export default withCars(withChoosedCar(withMapControl(withAuth(LayerMapControl))));
